module.exports = __webpack_public_path__ + "static/media/Vectorfolder_close.c8eb8af5.svg";